import React from 'react';
import { withRouter } from 'react-router-dom';
import { AllList, UseList } from '../components/ncash';
import DeliveryList from '../components/ncash/DeliveryList';
import DeliveryStatic from '../components/ncash/DeliveryStatic';
import { Input, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { httpPost, httpUrl } from '../api/httpClient';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../const';
import { updateCalculateHour } from '../actions/loginAction';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {modalStyle, modalErrorStyle} from "../lib/util/codeUtil";

class Calculate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listType: 0,
      calculateHour: 0,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.getCalculateHour();
  }

  getCalculateHour = () => {
    let hour = reactLocalStorage.getObject(Const.appName + '#calculateHour');

    this.setState({
      calculateHour: hour,
    });
  };
  setCalculateHour = () => {
    reactLocalStorage.setObject(
      Const.appName + '#calculateHour',
      this.state.calculateHour
    );
  };
  onChangeCalculateHour = () => {
    const self = this;
    if (self.state.calculateHour < 0 || self.state.calculateHour > 9) {
      Modal.error({
        title: '정산 시각 설정 오류',
        content: <div>설정 시각은 0시 ~ 9시 까지만 설정 가능합니다.</div>,
        ...modalErrorStyle,
      });
    } else {
      Modal.confirm({
        ...modalStyle,
        content: '정산 시각을 변경 하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
        onOk() {
          httpPost(httpUrl.updateCalculateHour, [], {
            userIdx: self.props.loginReducer.loginInfo.idx,
            calculateHour: self.state.calculateHour,
          })
            .then((result) => {
              Modal.info({
                title: '설정',
                content: <div>정산 시각이 변경되었습니다.</div>,
                ...modalStyle,
                onOk() {},
              });
              self.setCalculateHour();
            })
            .catch((e) => {
            });
        },
        onCancel() {},
      });
    }
  };

  render() {
    const skinType = Const.skinType.toUpperCase();
    return (
      <div className="calculate">
        <div className="calculate-main">
          {/* 상단 */}
          <div className="calculate-content">
            <div className="calculate-content-all">
              <div
                className="calculate-content-title"
                onClick={() => {
                  this.setState({ listType: 0 });
                }}>
                <div
                  className={this.state.listType === 0 && skinType === "GOGOIT" ?
                      'gogoit-calculate-content-title-text-color'
                      :
                    this.state.listType === 0
                      ? 'calculate-content-title-text-color'
                      : 'calculate-content-title-text'
                  }>
                  예치금 내역
                </div>
              </div>
              <div
                className="calculate-content-title2"
                onClick={() => {
                  this.setState({ listType: 1 });
                }}>
                <div
                  className={this.state.listType === 1 && skinType === "GOGOIT" ?
                      'gogoit-calculate-content-title2-text-color'
                      :
                    this.state.listType === 1
                      ? 'calculate-content-title2-text-color'
                      : 'calculate-content-title2-text'
                  }>
                  예치금 통계
                </div>
              </div>
              <div
                className="calculate-content-title2"
                onClick={() => {
                  this.setState({ listType: 2 });
                }}>
                <div
                  className={this.state.listType === 2 && skinType === "GOGOIT" ?
                      'gogoit-calculate-content-title2-text-color'
                      :
                      this.state.listType === 2
                          ? 'calculate-content-title2-text-color'
                          : 'calculate-content-title2-text'
                  }>
                  배달비 내역
                </div>
              </div>

              <div
                className="calculate-content-title2"
                onClick={() => {
                  this.setState({ listType: 3 });
                }}>
                <div
                  className={this.state.listType === 3 && skinType === "GOGOIT" ?
                      'gogoit-calculate-content-title2-text-color'
                      :
                      this.state.listType === 3
                          ? 'calculate-content-title2-text-color'
                          : 'calculate-content-title2-text'
                  }>
                  매출 통계
                </div>
              </div>

              <div className="calculate-content-other">
                <div className="calculate-content-other-hour1">
                  <div className="calculate-content-other-hour2">
                    정산 시각 :
                    <div className="calculate-content-other-hour-field-port">
                      <Input
                        type="number"
                        pattern="[0-9]*"
                        value={this.state.calculateHour}
                        onFocus={() => {}}
                        autoComplete="off"
                        placeholder="0 ~ 9"
                        min="0"
                        max="9"
                        style={{ borderRadius: '7px', fontSize: '11px' }}
                        maxLength={1}
                        onKeyUp="this.value=this.value.replace(/[^0-9]/g,'');"
                        onChange={(e) => {
                          this.setState({
                            calculateHour: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div
                      className={skinType === "GOGOIT" ? "gogoit-calculate-content-other-hour-btn": "calculate-content-other-hour-btn"}
                      onClick={() => {
                        this.onChangeCalculateHour();
                      }}>
                      변경
                    </div>
                  </div>
                </div>
              </div>

              {/* 지출내역 조회 */}
              {this.state.listType === 1 && (
                <div className="calculate-adjustment-content-btn-right">
                  {/* <div className="calculate-adjustment-content-btn" onClick={() => { }}>
                                        배달료
                                    <div className="calculate-adjustment-content-btn-text">
                                        280,000원
                                    </div>
                                    </div> */}
                  {/* <div className="calculate-adjustment-content-btn2" onClick={() => { }}>
                                        부가세
                                    <div className="calculate-adjustment-content-btn2-text">
                                            20,000원
                                    </div>
                                    </div> */}
                </div>
              )}
            </div>
          </div>

          {/* 전체내역 */}
          {this.state.listType === 0 && (
            <div className="calculate-element">
              <div className="calculate-element-menu"></div>
              {this.state.listType === 0 && <AllList />}
            </div>
          )}

          {/* 지출내역 */}
          {this.state.listType === 1 && <UseList />}

          {/* 배달내역 */}
          {this.state.listType === 2 && <DeliveryList />}

          {/* 배달내역 */}
          {this.state.listType === 3 && <DeliveryStatic />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer } = state;
  return { loginReducer };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateCalculateHour,
    },
    dispatch
  );
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Calculate)
);
